import { useCallback } from 'react';

import {
  StoreTrackingAttributes,
  useFavouriteStoreTracking,
} from '@/modules/shop/hooks/useFavouriteStoreTracking';
import {
  isStoreModel,
  OfferModel,
  StoreModel,
} from '@/modules/shop/models/offerModels';
import { useFavouriteStoresContext } from '@/modules/shop/providers/FavouriteStoresContext';

const useFavouriteStore = (
  merchantId: number,
  merchantOffer: StoreModel | OfferModel
) => {
  const { stores, updateStore } = useFavouriteStoresContext();
  const { trackFavourite } = useFavouriteStoreTracking();

  const isFavourite = !!stores?.[merchantId];

  const updateFavouriteStore = useCallback(
    async (isFavourite: boolean) => {
      let store: StoreTrackingAttributes;
      if (isStoreModel(merchantOffer)) {
        store = {
          merchantId: merchantOffer.merchantId,
          hyphenatedString: merchantOffer.hyphenatedString,
          clientCommissionString: merchantOffer.clientCommissionString,
          name: merchantOffer.name,
        };
      } else {
        store = {
          merchantId: merchantOffer.merchant.id,
          hyphenatedString: merchantOffer.merchant.hyphenatedString,
          clientCommissionString: merchantOffer.clientCommissionString,
          name: merchantOffer.merchant.name,
        };
      }

      await updateStore(merchantId, isFavourite);
      trackFavourite(isFavourite, store);
    },
    [merchantId, merchantOffer, trackFavourite, updateStore]
  );

  return { isFavourite, updateFavouriteStore };
};

export default useFavouriteStore;
